// How a time of day reads (CER-232): "3:30 PM" or "15:30", the way the
// person's phone or browser is set. Every clock time either app shows goes
// through here, so a reminder, a setting and a calendar event never disagree.
// Each app says which style at start (setClockStyle); until then, 12-hour.
// It imports nothing, so Deno can load it as it is.

let hour24 = false;

/** Say which style this device uses: true for 24-hour. */
export function setClockStyle(is24Hour: boolean): void {
  hour24 = is24Hour;
}

/** Whether times read in 24-hour style here. */
export const clockIs24Hour = (): boolean => hour24;

/** "HH:MM" (or "HH:MM:SS") as it reads: "3:30 PM" or "15:30". */
export function formatClockTime(hhmm: string): string {
  const hour = Number(hhmm.slice(0, 2));
  const minutes = hhmm.slice(3, 5);
  if (hour24) return `${String(hour).padStart(2, '0')}:${minutes}`;
  return `${hour % 12 || 12}:${minutes} ${hour < 12 ? 'AM' : 'PM'}`;
}

/** An instant's clock as it reads in `timeZone` (the device's own when left out). */
export function formatInstantClock(instant: string | Date, timeZone?: string): string {
  const parts = new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone })
    .formatToParts(typeof instant === 'string' ? new Date(instant) : instant);
  const part = (type: string) => parts.find((p) => p.type === type)?.value ?? '00';
  return formatClockTime(`${part('hour')}:${part('minute')}`);
}

/** Whether a browser's own locale reads times in 24-hour style; the website's answer for setClockStyle. */
export function localeUses24Hour(): boolean {
  // Read from the formatted parts: an AM/PM marker means 12-hour, whatever the library's typings know.
  return !new Intl.DateTimeFormat(undefined, { hour: 'numeric' }).formatToParts(new Date(2026, 0, 1, 15)).some((part) => part.type === 'dayPeriod');
}
